
      import API from "!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/pages/account/partials/account-order-details/partials/order-products/styles.css.ts.vanilla.css\",\"source\":\"Ll8xM3FibHZ0MCB7CiAgbWluLXdpZHRoOiB2YXIoLS1fMTh3NzZidzF2KTsKICB0ZXh0LWRlY29yYXRpb246IHVuZGVybGluZTsKICBtYXJnaW4tdG9wOiB2YXIoLS1fMTh3NzZid2MpOwogIGZvbnQtd2VpZ2h0OiB2YXIoLS1fMTh3NzZidzN3KTsKfQpAbWVkaWEgc2NyZWVuIGFuZCAobWF4LXdpZHRoOiA3NjhweCkgewogIC5fMTNxYmx2dDAgewogICAgbWluLXdpZHRoOiB2YXIoLS1fMTh3NzZidzF1KTsKICAgIG1hcmdpbi10b3A6IHZhcigtLV8xOHc3NmJ3OSk7CiAgfQp9\"}!./extracted.js";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/pages/account/partials/account-order-details/partials/order-products/styles.css.ts.vanilla.css\",\"source\":\"Ll8xM3FibHZ0MCB7CiAgbWluLXdpZHRoOiB2YXIoLS1fMTh3NzZidzF2KTsKICB0ZXh0LWRlY29yYXRpb246IHVuZGVybGluZTsKICBtYXJnaW4tdG9wOiB2YXIoLS1fMTh3NzZid2MpOwogIGZvbnQtd2VpZ2h0OiB2YXIoLS1fMTh3NzZidzN3KTsKfQpAbWVkaWEgc2NyZWVuIGFuZCAobWF4LXdpZHRoOiA3NjhweCkgewogIC5fMTNxYmx2dDAgewogICAgbWluLXdpZHRoOiB2YXIoLS1fMTh3NzZidzF1KTsKICAgIG1hcmdpbi10b3A6IHZhcigtLV8xOHc3NmJ3OSk7CiAgfQp9\"}!./extracted.js";
       export default content && content.locals ? content.locals : undefined;
